/**
 * Shown when the bundle was built without knowing where its backend is.
 *
 * This is a deploy mistake, not a user mistake, so it names the missing variables
 * and the command that fills them in — the two things needed to fix it — instead
 * of a blank page and a console error nobody will look at.
 */

import { Section } from './components/ui';
import './styles/global.css';

export function SetupNeeded({ problems }: { problems: readonly string[] }) {
  return (
    <div
      style={{
        maxWidth: '44rem',
        margin: '0 auto',
        padding: 'var(--space-xl) var(--space-lg)',
      }}
    >
      <h1 style={{ font: 'var(--text-title-1)' }}>AlohaMula is not configured</h1>
      <p style={{ color: 'var(--color-text-secondary)', marginTop: 'var(--space-xs)' }}>
        This build does not know where its backend is, so there is nothing it can
        show yet.
      </p>

      <Section title="Missing">
        <div className="card" style={{ padding: 'var(--space-md)' }}>
          <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
            {problems.map((name) => (
              <li key={name} className="numeric">
                {name}
              </li>
            ))}
          </ul>
        </div>
      </Section>

      <Section title="How to fix it">
        <div className="card" style={{ padding: 'var(--space-md)' }}>
          <p style={{ marginTop: 0 }}>
            Read the values out of the deployed stack and rebuild:
          </p>
          <pre
            style={{
              margin: 0,
              padding: 'var(--space-sm)',
              borderRadius: 'var(--radius-sm)',
              background: 'var(--color-surface-sunken)',
              overflowX: 'auto',
              font: 'var(--text-caption)',
              fontFamily: 'var(--font-mono)',
            }}
          >
            {'cd web\n./scripts/configure-web.sh\nnpm run build'}
          </pre>
        </div>
      </Section>
    </div>
  );
}
